import type { ApiService } from '~/services/ApiService'
import type { Notification } from '~~/api/models'

export class NotificationService {
  private apiService: ApiService

  constructor (apiService: ApiService) {
    this.apiService = apiService
  }

  async getNotifications (read: boolean = false): Promise<Notification[]> {
    return this.apiService.get<Notification[]>(`/api/notifications?filter[isRead][eq]=${read}`)
  }

  async markAllNotificationsAsRead (): Promise<void> {
    return this.apiService.post(`/api/notifications/markAllAsRead`)
  }
}